export const countCharacters = value => Array.from(String(value || '')).length

export const getCommentPayloadCharacterCount = content => countCharacters(content)

export const extractCommentPlainText = content => {
	if (!content) {
		return ''
	}

	if (typeof document === 'undefined') {
		return String(content).replace(/<[^>]*>/g, '').trim()
	}

	const parser = document.createElement('div')
	parser.innerHTML = String(content)
	return (parser.textContent || parser.innerText || '').trim()
}

export const isCommentEdited = comment => {
	if (!comment) {
		return false
	}

	if (typeof comment.is_edited === 'boolean') {
		return comment.is_edited
	}

	if (!comment.created_at || !comment.updated_at) {
		return false
	}

	const createdAt = new Date(comment.created_at).getTime()
	const updatedAt = new Date(comment.updated_at).getTime()

	if (Number.isNaN(createdAt) || Number.isNaN(updatedAt)) {
		return false
	}

	return updatedAt > createdAt
}
